import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IntegrationConnector from '../components/IntegrationConnector'
import { APP_URL, OUTREACH_CLIENT_ID } from 'constants/ResourcesConstants'
import { Icon, ToolTip, Button } from '@driftt/tide-core-legacy'
import Fragment from 'react-dot-fragment'
import cx from 'classnames'


import * as IntegrationsActions from 'app/modules/integrations/actions'
import * as IntegrationsSelectors from 'app/modules/integrations/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'

const OutreachPayload = {
  client_id: OUTREACH_CLIENT_ID,
  response_type: 'code',
  scope: 'prospects.all sequences.all sequenceStates.all mailboxes.all sequenceSteps.all',
  redirect_uri: `${APP_URL}/accept-integration/outreach`,
}

const OutreachAuthUrl = 'https://accounts.outreach.io/oauth/authorize'

class Outreach extends Component {

  componentDidMount() {
    this.props.actions.fetchOutreachStatus()
  }

  onTabFocus = (e) => {
    this.props.actions.fetchOutreachStatus()
    window.removeEventListener('focus', this.onTabFocus)
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.isConnected === true && prevProps.isConnected === false) {
      this.props.actions.fetchOutreachStatus()
      window.addEventListener('focus', this.onTabFocus)
    }
  }

  render() {

    const { isConnected, isDriftConnectedOnOutreachSide, orgId } = this.props

    const isDriftConnectedOutreachDisconnected = isConnected && !isDriftConnectedOnOutreachSide

    return (
      <div className={cx({ "outreach--is-halfway-connected": isDriftConnectedOutreachDisconnected })}>
        <p className={"outreach-paragraph"}>Connect your account to drive seamless conversations between chat and email! <a href="https://gethelp.drift.com/hc/en-us/articles/360019505134-How-to-Connect-Drift-and-Outreach" target="_blank" rel="noopener noreferrer"> Learn more </a> </p>
        <div className="outreach-list-item">
          <div className="outreach-list-item-icon">
            <Icon width={26} height={24} name='chat-1' />
          </div>
          <span className="outreach-list-item-description">Continue the conversation from email and turn on <a target="_blank" rel="noopener noreferrer" href="/playbooks/list/chat"> your Outbound Welcome Message Playbook</a> to automatically chat with people with people who click on your Outreach Sequence.</span>
        </div>

        <div className="outreach-list-item">
          <div className="outreach-list-item-icon">
            <Icon width={28} height={24} name='user-check' />
          </div>
          <span className="outreach-list-item-description">When a Drift contact is enrolled, if they don’t exist in your Outreach account yet, we’ll automatically create a new prospect for you in Outreach with any contact attributes we have. </span>
        </div>

        <div className="outreach-list-item">
          <div className="outreach-list-item-icon">
            <Icon width={25} height={24} name='fork-arrows' />
          </div>
          <span className="outreach-list-item-description">You can <a href="https://accounts.outreach.io?pending[path]=triggers" rel="noopener noreferrer" target="_blank"> customize your team’s Outreach Triggers </a> to automatically take an action based on a Drift event. For example, when a new Drift conversation is started from a sequence, you can create an action to automatically unenroll that prospect. </span>
        </div>

        <div>
          {isDriftConnectedOutreachDisconnected &&
            <Fragment>
              <hr />
              <div className="outreach-integration-subheadline"> Almost there! Connect your Drift account in Outreach </div>
              <div className="outreach-integration-copy"> To automatically unenroll contacts or create a task when a new Drift conversation is started, <span className="outreach-integration-bold"> you must connect your Drift account in Outreach. </span> </div>
              <ToolTip
                flow="up"
                component={<div>You must be an Admin in <br /> Outreach to connect this <br /> integration</div>}>
                <Button
                  href="https://accounts.outreach.io/apps/drift"
                  type="primary"
                  target="_blank"
                  icon="expand"
                  className="outreach-connect-button">
                  Connect Drift in Outreach
              </Button>
              </ToolTip>
            </Fragment>
          }

          {!isConnected &&
            <div className="connect-container">
              {isDriftConnectedOnOutreachSide &&
                <Fragment>
                  <hr />
                  <div className="outreach-integration-subheadline outreach-integration-one-last-step"> One last step to complete your Drift and Outreach integration! </div>
                </Fragment>
              }
              <IntegrationConnector
                integrationId="outreach"
                isOauth={true}
                oauthLink={OutreachAuthUrl}
                oauthQueryParams={{
                  ...OutreachPayload,
                  state: JSON.stringify({
                    isDriftConnectedOnOutreachSide,
                    orgId
                  })
                }}
                title="Connect Outreach"
                connectorType="button"
                buttonType="primary"
                className="outreach-integration-connector"
                tooltipText={<div>You must be an Admin in <br /> Outreach to connect this <br /> integration</div>} />
            </div>
          }
        </div>
      </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    isOutreachPending: IntegrationsSelectors.isOutreachStatusPending(state),
    isDriftConnectedOnOutreachSide: IntegrationsSelectors.isOutreachConnected(state),
    isIntegrationsPending: IntegrationsSelectors.connectionsFetchPending(state) || IntegrationsSelectors.connectionsUpdatePending(state),
    orgId: OrgSelectors.orgId(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchOutreachStatus: IntegrationsActions.fetchOutreachStatus,
      fetchIntegrations: IntegrationsActions.fetchIntegrationStates,
    },
    dispatch
  ),
})


export default connect(mapStateToProps, mapDispatchToProps)(Outreach)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Outreach.js